import { useState, useEffect } from 'react';

interface TeamMember {
  id: number;
  name: string;
  role: string;
  gradient: string;
}

const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: 'Sezgin Şener',
    role: 'Co-Founder & CEO',
    gradient: 'from-blue-800 to-blue-950',
  },
  {
    id: 2,
    name: 'Fatih Gökmen',
    role: 'Team Lead',
    gradient: 'from-indigo-900 to-indigo-950',
  },
  {
    id: 3,
    name: 'Emrah Günay',
    role: 'Backend Developer',
    gradient: 'from-purple-800 to-purple-950',
  },
  {
    id: 4,
    name: 'Eyüp Kayak',
    role: 'Backend Developer',
    gradient: 'from-teal-800 to-teal-950',
  },
  {
    id: 5,
    name: 'Şenol Günaydın',
    role: 'Backend Developer',
    gradient: 'from-cyan-800 to-cyan-950',
  },
  {
    id: 6,
    name: 'Gamze Gülnur Düzgün',
    role: 'UI/UX Designer',
    gradient: 'from-pink-800 to-pink-950',
  },
  {
    id: 7,
    name: 'Utku Tunçal',
    role: 'Frontend Developer',
    gradient: 'from-orange-800 to-orange-950',
  },
  {
    id: 8,
    name: 'Rıdvan Polat',
    role: 'Cyber Security',
    gradient: 'from-red-800 to-red-950',
  },
  {
    id: 9,
    name: 'Hasan Alper Düzgün',
    role: 'Mobile Developer',
    gradient: 'from-green-800 to-green-950',
  },
  {
    id: 10,
    name: 'Mikail Köse',
    role: 'Mobile Developer',
    gradient: 'from-amber-800 to-amber-950',
  },
  {
    id: 11,
    name: 'Emrah Doğru',
    role: 'Software Architect',
    gradient: 'from-indigo-900 to-slate-900',
  },
];

export function TeamSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [prevActiveIndex, setPrevActiveIndex] = useState<number | undefined>(
    undefined
  );
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleCardClick = (index: number) => {
    if (index !== activeIndex) {
      setPrevActiveIndex(activeIndex);
      setActiveIndex(index);
      // Clear previous index after animation
      setTimeout(() => setPrevActiveIndex(undefined), 300);
    }
  };

  const getCardStyles = (index: number, prevActiveIndex?: number) => {
    const isActive = index === activeIndex;
    const totalCards = teamMembers.length;

    if (isMobile) {
      // Mobil için desktop mantığının aynısı
      if (isActive) {
        return {
          width: '60%',
          height: '300px',
          opacity: 1,
          zIndex: 3,
          cursor: 'default',
          transition: 'all 500ms ease-in-out',
        };
      }

      // Aktif karttan sonraki 2 kartı göster
      const nextIndices = [];
      for (let i = 1; i <= 2; i++) {
        const nextIndex = (activeIndex + i) % totalCards;
        nextIndices.push(nextIndex);
      }

      const visiblePosition = nextIndices.indexOf(index);

      if (visiblePosition === -1) {
        return {
          display: 'none',
        };
      }

      // Eğer bu kart önceden aktifti ve şimdi değilse, animasyon geçişi
      const wasActive =
        prevActiveIndex !== undefined && index === prevActiveIndex;

      return {
        width: '18%',
        height: '300px',
        opacity: 1,
        zIndex: 2,
        cursor: 'pointer',
        transition: wasActive
          ? 'all 300ms ease-in-out'
          : 'all 500ms ease-in-out',
      };
    }

    // Desktop logik (mevcut)
    if (isActive) {
      return {
        width: '520px',
        height: '384px',
        left: '0px',
        opacity: 1,
        zIndex: 3,
        cursor: 'default',
        transition: 'all 500ms ease-in-out',
      };
    }

    const nextIndices = [];
    for (let i = 1; i <= 2; i++) {
      const nextIndex = (activeIndex + i) % totalCards;
      nextIndices.push(nextIndex);
    }

    const visiblePosition = nextIndices.indexOf(index);

    if (visiblePosition === -1) {
      return {
        width: '64px',
        height: '384px',
        left: '700px',
        opacity: 0,
        zIndex: 1,
        cursor: 'pointer',
        transition: 'all 500ms ease-in-out',
      };
    }

    const smallCardPosition = 532 + visiblePosition * 84;
    const wasActive =
      prevActiveIndex !== undefined && index === prevActiveIndex;

    return {
      width: '64px',
      height: '384px',
      left: `${smallCardPosition}px`,
      opacity: 1,
      zIndex: 2,
      cursor: 'pointer',
      transition: wasActive ? 'all 300ms ease-in-out' : 'all 500ms ease-in-out',
    };
  };

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-team-section {
              padding: 40px 20px !important;
            }
            .mobile-team-content {
              position: static !important;
              display: flex !important;
              flex-direction: column !important;
              gap: 32px !important;
              width: 100% !important;
              height: auto !important;
              max-width: 100% !important;
            }
            .mobile-team-left {
              position: static !important;
              width: 100% !important;
              left: 0 !important;
              top: 0 !important;
              height: auto !important;
              flex: none !important;
            }
            .mobile-team-cards-container {
              position: relative !important;
              left: 0 !important;
              top: 0 !important;
              width: 100% !important;
              height: 300px !important;
              display: flex !important;
              align-items: center !important;
              gap: 8px !important;
            }
            .mobile-team-card {
              position: relative !important;
              border-radius: 24px !important;
              overflow: hidden !important;
              transition: all 500ms ease-in-out !important;
              cursor: pointer !important;
            }
            .mobile-active-card {
              width: 60% !important;
              height: 300px !important;
            }
            .mobile-small-card {
              width: 18% !important;
              height: 300px !important;
            }
            .mobile-hidden-card {
              display: none !important;
            }
          }
        `,
        }}
      />
      <div className="w-full h-[580px] bg-slate-950 flex justify-center items-center mobile-team-section overflow-hidden">
        <div className="w-full max-w-[1200px] h-[580px] relative mobile-team-content">
          <div className="w-80 h-96 left-[64px] top-[80px] absolute inline-flex flex-col justify-start items-start overflow-hidden mobile-team-left">
            <div className="px-3 bg-gray-800 rounded-[100px] inline-flex justify-center items-center gap-2 overflow-hidden">
              <div className="size-1.5 bg-sky-300 rounded-full" />
              <div className="justify-start text-sky-300 text-xs font-medium font-['Inter'] tracking-wide">
                EKİBİMİZ
              </div>
            </div>
            <div className="w-px h-5 relative" />
            <div className="w-80 justify-start text-white text-4xl font-bold font-['Inter'] leading-[48px]">
              Ekibimizle
              <br />
              Tanışın
            </div>
            <div className="w-px h-4 relative" />
            <div className="w-72 justify-start text-slate-500 text-base font-normal font-['Inter'] leading-6">
              Farklı disiplinlerden gelen, ortak bir tutkuyla birleşen
              mühendisler, tasarımcılar ve strateji uzmanlarından oluşan
              ekibimiz.
            </div>
            <div className="flex items-center gap-2 mt-4">
              <div className="flex items-center gap-1">
                <div className="w-2 h-2 bg-sky-300 rounded-full animate-pulse" />
                <span className="text-sky-300 text-sm font-medium font-['Inter']">
                  Kartlara tıklayarak keşfedin
                </span>
                <svg
                  className={`w-4 h-4 text-sky-300 ml-1 ${isMobile ? '' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={isMobile ? 'M19 9l-7 7-7-7' : 'M9 5l7 7-7 7'}
                  />
                </svg>
              </div>
            </div>
          </div>

          <div
            className="mobile-team-cards-container relative"
            style={{
              left: '448px',
              top: '80px',
              position: 'absolute',
              width: '700px',
              height: '384px',
            }}
          >
            {isMobile ? (
              // Mobil için özel sıralama: önce aktif kart, sonra sonraki kartlar
              <>
                {/* Aktif kart */}
                {teamMembers.map((member, index) => {
                  if (index !== activeIndex) return null;
                  const styles = getCardStyles(index, prevActiveIndex);

                  return (
                    <div
                      key={member.id}
                      className={`rounded-3xl overflow-hidden transition-all duration-500 ease-in-out mobile-team-card ${member.gradient}`}
                      style={{
                        ...styles,
                        boxShadow:
                          '0px 0px 32px 0px rgba(118,188,232,0.25), 0px 0px 80px 0px rgba(118,188,232,0.10)',
                        outline: '1px solid rgba(135, 206, 235, 0.3)',
                        outlineOffset: '-1px',
                      }}
                    >
                      <div
                        className={`w-full h-full left-0 top-0 absolute bg-gradient-to-b ${member.gradient}`}
                      />
                      <div className="size-20 left-[220px] top-[60px] absolute bg-white bg-opacity-10 rounded-full" />
                      <div className="w-36 h-24 left-[190px] top-[160px] absolute bg-white bg-opacity-10 rounded-full" />
                      <div
                        className="w-full h-full left-0 top-0 absolute"
                        style={{
                          background:
                            'linear-gradient(270deg, rgba(2,8,23,0.90) 0%, rgba(2,8,23,0.30) 50%, rgba(0,0,0,0) 100%)',
                        }}
                      />
                      <div className="left-[20px] bottom-[40px] absolute justify-start text-white text-base font-bold font-['Inter']">
                        {member.name}
                      </div>
                      <div className="left-[20px] bottom-[20px] absolute justify-start text-sky-300 text-xs font-normal font-['Inter']">
                        {member.role}
                      </div>
                    </div>
                  );
                })}

                {/* Sonraki 2 kart */}
                {teamMembers.map((member, index) => {
                  const totalCards = teamMembers.length;
                  const nextIndices = [];
                  for (let i = 1; i <= 2; i++) {
                    const nextIndex = (activeIndex + i) % totalCards;
                    nextIndices.push(nextIndex);
                  }

                  if (!nextIndices.includes(index)) return null;

                  const styles = getCardStyles(index, prevActiveIndex);

                  return (
                    <div
                      key={member.id}
                      onClick={() => handleCardClick(index)}
                      className={`rounded-3xl overflow-hidden transition-all duration-500 ease-in-out mobile-team-card ${member.gradient}`}
                      style={{
                        ...styles,
                        outline: '1px solid rgba(255, 255, 255, 0.1)',
                        outlineOffset: '-1px',
                      }}
                    >
                      <div
                        className={`w-full h-full left-0 top-0 absolute bg-gradient-to-b ${member.gradient}`}
                      />
                      <div className="size-9 left-[18px] top-[80px] absolute bg-white bg-opacity-10 rounded-full" />
                      <div className="size-14 left-[8px] top-[160px] absolute bg-white bg-opacity-10 rounded-full" />
                      <div
                        className="w-full h-full left-0 top-0 absolute"
                        style={{
                          background:
                            'linear-gradient(270deg, rgba(2,8,23,0.90) 0%, rgba(2,8,23,0.30) 50%, rgba(0,0,0,0) 100%)',
                        }}
                      />
                      <div className="left-[8px] bottom-[15px] absolute justify-start text-white text-xs font-bold font-['Inter']">
                        {member.name}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              // Desktop görünüm
              teamMembers.map((member, index) => {
                const styles = getCardStyles(index, prevActiveIndex);
                const isActive = index === activeIndex;

                if (styles.display === 'none') return null;

                return (
                  <div
                    key={member.id}
                    onClick={() => handleCardClick(index)}
                    className={`${isMobile ? '' : 'absolute'} rounded-3xl overflow-hidden transition-all duration-500 ease-in-out mobile-team-card ${
                      !isMobile && isActive ? 'mobile-active-card' : ''
                    } ${member.gradient}`}
                    style={{
                      ...styles,
                      ...(!isMobile ? { top: '0px' } : {}),
                      boxShadow: isActive
                        ? '0px 0px 32px 0px rgba(118,188,232,0.25), 0px 0px 80px 0px rgba(118,188,232,0.10)'
                        : 'none',
                      outline: isActive
                        ? '1px solid rgba(135, 206, 235, 0.3)'
                        : '1px solid rgba(255, 255, 255, 0.1)',
                      outlineOffset: '-1px',
                    }}
                  >
                    <div
                      className={`w-full h-full left-0 top-0 absolute bg-gradient-to-b ${member.gradient}`}
                    />

                    {isActive ? (
                      <>
                        <div className="size-20 left-[220px] top-[60px] absolute bg-white bg-opacity-10 rounded-full" />
                        <div className="w-36 h-24 left-[190px] top-[160px] absolute bg-white bg-opacity-10 rounded-full" />
                        <div
                          className="w-full h-full left-0 top-0 absolute"
                          style={{
                            background:
                              'linear-gradient(270deg, rgba(2,8,23,0.90) 0%, rgba(2,8,23,0.30) 50%, rgba(0,0,0,0) 100%)',
                          }}
                        />
                        <div className="left-[20px] bottom-[40px] absolute justify-start text-white text-base font-bold font-['Inter']">
                          {member.name}
                        </div>
                        <div className="left-[20px] bottom-[20px] absolute justify-start text-sky-300 text-xs font-normal font-['Inter']">
                          {member.role}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="size-9 left-[18px] top-[80px] absolute bg-white bg-opacity-10 rounded-full" />
                        <div className="size-14 left-[8px] top-[160px] absolute bg-white bg-opacity-10 rounded-full" />
                        <div
                          className="w-full h-full left-0 top-0 absolute"
                          style={{
                            background:
                              'linear-gradient(270deg, rgba(2,8,23,0.90) 0%, rgba(2,8,23,0.30) 50%, rgba(0,0,0,0) 100%)',
                          }}
                        />
                      </>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
}
